<template>
  <div class="home text-center">
    <Login />
  </div>
</template>

<script>
import Login from '../components/Login.vue';

export default {
  name: 'Home',

  components: {
    Login,
  },
};
</script>

<style scoped>
h1 {
  margin: 50px;
}
</style>
